<fsx-file-upload-wrapper
  #fileUploadField
  [additionalFieldSpec]="additionalFieldSpec"
  [fileUploadDocumentInfos]="(documentInfos$ | async) || []"
  (filesUploadedWrapperEvent)="onFilesUploadedEvent($event)"
  (fileRemovedEvent)="fileRemovedEventHandler($event)"
>
</fsx-file-upload-wrapper>
